import { ref } from 'vue'
import Lesson from '@/models/Lesson'
import { useLoading } from '@/composables/useLoading'

export default function MarathonController () {
  const { loading, loadingOn, loadingOff } = useLoading()

  const marathon = ref([])

  const mess = ref(null)
  const messVisible = ref(false)
  const setMess = (err) => {
    mess.value = err
    messVisible.value = true
    setTimeout(() => (messVisible.value = false), 2000)
  }

  const error = ref(null)
  const setError = (err) => {
    error.value = err
    setTimeout(() => (error.value = ''), 3000)
  }

  const getMarathon = async () => {
    loadingOn()
    const response = await fetch('https://valeriya-artist-admin.ru/api/marathon', {
      method: 'GET',
      headers: {
        Authorization: localStorage.getItem('admin_token')
      }
    })
    const res = await response.json()
    if (response.ok) {
      marathon.value = res.marathon.map((o) => new Lesson(o))
    } else setError(res.err)
    loadingOff()
  }

  const marathonApiWrapper = async (url, payload) => {
    loadingOn()
    const response = await fetch(`https://valeriya-artist-admin.ru/api/${url}`, {
      method: 'POST',
      headers: {
        Authorization: localStorage.getItem('admin_token')
      },
      body: JSON.stringify(payload)
    })
    const res = await response.json()
    if (response.ok) {
      setMess(res.mess)
      getMarathon()
    } else setError(res.err)
    loadingOff()
  }

  const changeLessonPreview = async (payload) => {
    loadingOn()
    const response = await fetch('https://valeriya-artist-admin.ru/api/marathon/preview', {
      method: 'POST',
      headers: {
        Authorization: localStorage.getItem('admin_token')
      },
      body: payload
    })
    const res = await response.json()
    if (response.ok) {
      setMess(res.mess)
      getMarathon()
    } else setError(res.err)
    loadingOff()
  }

  return {
    getMarathon,
    marathon,
    marathonApiWrapper,
    changeLessonPreview,
    mess,
    messVisible,
    error,
    loading
  }
}
